/**
 * @generated SignedSource<<379542c93de1899e7df4c613f7c991f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleResultsFormFields_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participativeModuleIds",
      "storageKey": null
    }
  ],
  "type": "PageSectionParticipativeModuleResults",
  "abstractKey": null
};

node.hash = "75fc4535695aca14efb2e1370fc17095";

module.exports = node;
